module.exports = __webpack_public_path__ + "static/media/avatar19.7057ea66.png";